import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-delete\"><path d=\"M13 3h-3L9 2H7L6 3H3v1h1v8c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V4h1zm-2 9c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1V4h6z\" /><path d=\"M6.3 5h1v6.5h-1zm2.5 0h1v6.5h-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol